
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, RequisitionLookupViewModel } from "@tylertech/tyler-api-types";

/**
 * RequisitionLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class RequisitionLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<RequisitionLookupViewModel[]>> {
        return this.$apiService.sendAuth("IRequisitionLookupService/Lookup", pCriteria);
    }
}
